import { ICenterBase, IListItem } from '@nkr/models/index';

export interface IIncidentReportLookupData {
    memberCenters: ICenterBase[];
    incidentCategoryTypeList: IListItem[];
    incidentOriginTypeList: IListItem[];
    incidentStatusList: IListItem[];
    actionList: IListItem[];
    mentorList: { id: number, firstName: string, lastName: string, email: string }[],
    userId: number;
    fullName: string;
    donorConnectGroup: number;
}
